//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { transTimeFilter } from "../../../src/filters"
import { PitchShifter } from "./soundtouch.js"
import { unmute } from "./unmute.min.js"
const { WaveFile } = require("./wavefile.js")

import { Popover } from "vant"
import "vant/lib/popover/style/index"

const handleDocumentClick = (vm, e) => {
  if (!vm.$el || vm.$el.contains(e.target)) {
    return
  }
  vm.rateShow = false
}

const mergeArrayBuffers = arr => {
  if (arr instanceof ArrayBuffer) {
    return arr
  }
  if (arr instanceof Array) {
    const length = arr.reduce((acc, cur) => acc + cur.byteLength, 0)
    const arrBuffer = new ArrayBuffer(length)
    const merged = new Uint8Array(arrBuffer)
    let offset = 0
    for (let i = 0; i < arr.length; i++) {
      merged.set(new Uint8Array(arr[i]), offset)
      offset += arr[i].byteLength
    }
    return arrBuffer
  }
}
// , "gsm_ms", "pcm_s16le" 暂时不支持
const canDecodeNameList = ["adpcm_ima_wav"]

const decodeAudioFn = (vm, currentBuffer) => {
  if (canDecodeNameList.includes(vm.codecName)) {
    let arr = new Uint8Array(currentBuffer)
    const wavFile = new WaveFile()
    wavFile.fromBuffer(arr)
    wavFile.toALaw()
    currentBuffer = wavFile.toBuffer().buffer
  }

  vm.audioCtx.decodeAudioData(currentBuffer, audioBuffer => {
    let preNode = undefined
    if (vm.shifter) {
      vm.onPause()
      // 如果不是第一片，则使用同一个 node
      preNode = vm.isFirst ? undefined : vm.shifter._node
    }
    // vm.shifter && vm.onPause()
    vm.shifter = new PitchShifter(
      vm.audioCtx,
      audioBuffer,
      512,
      () => {
        // onEnd监听
        if (!vm.playing) {
          return
        }
        vm.onEnded()
        vm.$emit("ended", vm)
      },
      preNode
    )
    // 播放速度
    vm.shifter.tempo = vm.currentRate.value
    // 变调
    // shifter.pitch = 1.5
    // vm.gainNode.gain.value = 1.5
    vm.shifter.pitchSemitones = vm.pitchSemitones
    // 语音总时长
    vm.duration = vm.totalDuration || vm.shifter.duration
    // 监听播放事件
    vm.shifter.on("play", detail => {
      vm.playedTime = detail.timePlayed
      vm.progress = vm.duration > 0 ? ((vm.playedTime * 100) / (vm.duration * 100)).toFixed(5) * 100 : 0
      vm.$emit("timeupdate", vm)
    })

    // decodeAudioData需要时间，开始时间如果不是0的话就取当前播放时间
    vm.setCurrentTime(vm.startTime > 0 ? vm.playedTime : 0)

    // 自动播放
    if (vm.autoPlay) {
      vm.onClickPlay()
    }
  })
}

const ua = navigator.userAgent.toLowerCase()
let baseAudioCtx = null

const load = vm => {
  let currentBuffer = mergeArrayBuffers(vm.buffer)
  if (vm.isFirst) {
    const audioCtx =
      baseAudioCtx ||
      new (window.AudioContext || window.webkitAudioContext)({
        sampleRate: vm.sampleRate,
        latencyHint: 0.001
      })

    vm.audioCtx = audioCtx
  }
  // 如果不是第一个分片或者完整分片并且没有在loading则不去decode
  if (!vm.isFirst && currentBuffer.byteLength !== vm.size && !vm.loading) {
    return
  }
  decodeAudioFn(vm, currentBuffer)
}

export default {
  name: "VocAudioPlayerRemix",
  components: { Popover },
  filters: { transTimeFilter },
  props: {
    // 录音名称
    name: {
      type: String,
      default: ""
    },
    // 录音链接
    link: {
      type: String,
      default: "",
      required: true
    },
    // 语音类型
    mediaType: {
      type: String,
      default: "audio/wav"
    },
    // 总时长
    totalDuration: {
      type: Number,
      default: 0
    },
    // 自动播放
    autoPlay: {
      type: Boolean,
      default: true
    },
    startTime: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    buffer: {
      validator: value => {
        return Array.isArray(value) || value instanceof ArrayBuffer
      },
      default: () => []
    },
    pitchSemitones: {
      type: Number,
      default: 1.5
    },
    size: {
      type: Number,
      default: 0
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    showDownload: {
      type: Boolean,
      default: false
    },
    sampleRate: {
      type: Number,
      default: 8000
    },
    codecName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // 标志位
      // 用来判断是否处于播放状态
      playing: false,
      // 语音总时长
      duration: 0,
      // 当前已播放时间
      playedTime: 0,
      // 控制进度条
      progress: 0,
      rateShow: false,
      actions: [
        {
          text: "2.0x",
          value: 2.0
        },
        {
          text: "1.5x",
          value: 1.5
        },
        {
          text: "1.25x",
          value: 1.25
        },
        {
          text: "1.0x",
          value: 1.0
        },
        {
          text: "0.75x",
          value: 0.75
        },
        {
          text: "0.5x",
          value: 0.5
        }
      ],
      currentRate: {
        text: "1.0x",
        value: 1.0
      },
      audioCtx: undefined,
      shifter: undefined
    }
  },
  computed: {
    // audio dom
    audioRef() {
      return this.$refs["audioRef"]
    },
    actionsList() {
      return this.actions.map(item => {
        if (item.value === this.currentRate.value) {
          item.className = "active"
        } else {
          item.className = ""
        }
        return item
      })
    }
  },
  watch: {
    link() {
      load(this)
    },
    sampleRate: {
      immediate: true,
      handler(val, oldVal) {
        if (val && val !== oldVal) {
          baseAudioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: val, latencyHint: 0.001 })
          // 微信浏览器里面回调问题导致 iPhone 偶尔会拒绝播放
          if (ua.includes("micromessenger") && !ua.includes("wxwork")) {
            baseAudioCtx.resume()
          }
        }
      }
    }
  },
  mounted() {
    // 防止iphone 静音
    unmute(baseAudioCtx || new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 8000 }), true)

    document.addEventListener("click", e => handleDocumentClick(this, e))
    if (this.link) {
      load(this)
    }
  },
  methods: {
    isDragHorizontal(d2, d1) {
      return Math.abs(d2.clientX - d1.clientX) > Math.abs(d2.clientY - d1.clientY)
    },
    setCurrentTime(time = 0) {
      const { shifter } = this
      shifter && (shifter.percentagePlayed = time / shifter.duration)
    },
    /**
     * progress {Number} 进度比例，0~1的小数
     */
    seek(progress) {
      if (this.loading) {
        return
      }
      if (progress > 1) progress = 1
      if (progress < 0) progress = 0
      this.progress = progress * 100
      this.setCurrentTime(progress * this.duration)
      this.onPlay()
    },
    getStageWidth(dom) {
      return this.__stageWidth || (this.__stageWidth = dom.getBoundingClientRect().width)
    },
    onDragSeekStart(e) {
      this.__lastMove = e.touches[0]
    },
    onDragSeek(e) {
      let move = e.touches[0]
      if (this.__lastMove && this.isDragHorizontal(move, this.__lastMove) && e.cancelable) {
        e.preventDefault()
        e.stopPropagation()
        this.seek(this.progress / 100 + (move.clientX - this.__lastMove.clientX) / this.getStageWidth(e.currentTarget))
        this.__lastMove = move
      }
    },
    onClickSeek(e) {
      this.seek(e.offsetX / this.getStageWidth(e.currentTarget))
    },
    onClickPlay() {
      this.$emit("clickPlay", this)
      this.onPlay()
    },
    // 执行播放
    onPlay() {
      let { shifter, audioCtx } = this
      if (this.playing) {
        return
      }
      if (this.link) {
        if (this.duration - this.playedTime < 0.5) {
          this.setCurrentTime(0)
        }
        shifter.connect(audioCtx.destination)
        // gainNode.connect(audioCtx.destination)
        audioCtx
          .resume()
          .then(() => {
            this.playing = true
            this.$emit("play", this)
          })
          .catch(error => {
            this.playing = false
            console.log(error)
          })
      }
    },
    // 暂停播放
    onPause() {
      let { shifter } = this
      if (this.playing) {
        shifter.disconnect()
        shifter.off()
        this.playing = false
        this.$emit("pause", this)
      }
    },
    // 播放完成
    onEnded() {
      // 兼容单个播放器停止
      this.onPause()
    },
    // 快进或快退
    changeTime(type) {
      if (this.loading) {
        return
      }
      if (type === "back") {
        if (this.playedTime >= 15) {
          this.setCurrentTime(this.playedTime - 15)
        } else {
          this.setCurrentTime(0)
        }
      } else {
        if (this.playedTime < this.duration - 15) {
          this.setCurrentTime(this.playedTime + 15)
        } else {
          this.setCurrentTime(this.duration - 1)
        }
      }
      this.onClickPlay()
    },
    getContainer() {
      return this.$refs["voc-audio"]
    },
    selectRate(item) {
      let { shifter } = this
      this.currentRate = item
      shifter && (shifter.tempo = item.value)
    }
  },
  beforeDestroy() {
    this.shifter && this.shifter.clear()
    this.audioCtx && this.audioCtx.close()
  }
}
